import React, {useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { CommunicationContext } from '../../../context/communication-context';

const useStyles = makeStyles((theme) => ({
  root: {
    width:'100%',
    borderColor: 'darkgray'
  },
}));

export default function ControlAtlasPwdLogTabPanel(props) {
  console.log("render ControlAtlasPwdLogTabPanel");

  const classes = useStyles();
  const [communicationState, communicationDispatch] = useContext(CommunicationContext);

  return (
    <div>
      <TextareaAutosize className={classes.root}
        maxRows={40}
        defaultValue={communicationState.atlasPwdLogs}
      />
    </div>
  );
}
  